<!-- 设备管理-设备列表页面 -->
<template>
  <div class="drawPage">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="flex-valign left-tree">
        <div class="left-type_area sbar">
          <div class="flex-between valign-center">
            <span class="title">楼栋信息</span>
            <!-- <el-button
              type="primary"
              size="mini"
              icon="iconfont icon-iconfontfanhui"
              @click="retBtn"
              >{{ $t("cameraList.button.back") }}</el-button
            > -->
          </div>
          <div class="tree-container">
            <div class="area-search">
              <el-input
                placeholder="请输入搜索关键字"
                prefix-icon="el-icon-search"
                v-model="searchString"
                clearable
              >
              </el-input>
            </div>
            <el-scrollbar class="scroll-bar-view">
              <el-tree
                v-if="showTree"
                ref="tree"
                class="tree-content"
                :data="treeData"
                :expand-on-click-node="false"
                node-key="id"
                :default-expanded-keys="expandedKeys"
                render-after-expand
                :load="asyncLoadNode"
                :lazy="lazyLoad"
                :props="treeProps"
                :highlight-current="true"
                :filter-node-method="filterNode"
                @node-click="nodeClick"
              >
                <div
                  class="custom-tree-node"
                  :title="node.label"
                  slot-scope="{ node, data }"
                >
                  <i :class="iconList[data.type]"></i>
                  <div class="ml10 ell tree-label">{{ node.label }}</div>
                  <!-- <span v-if="buildingCode === data.id">
                    <div class="area-operator"
                         @click="addClick">
                      <el-button type="text"
                                 class="el-icon-plus"
                                 size="mini"
                                 v-if="data.type!=='2'"
                                 @click="() => appendArea(data)"></el-button>
                      <el-button v-if="data.parentCode !== '-1'"
                                 type="text"
                                 class="el-icon-delete-solid"
                                 size="mini"
                                 @click="() => removeArea(node, data)"></el-button>
                      <el-button type="text"
                                 class="el-icon-edit-outline"
                                 size="mini"
                                 @click="() => editArea(node, data)"></el-button>
                    </div>
                  </span> -->
                </div>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right right-content">
        <!-- 头部按钮 -->
        <div class="right-top">
          <!-- <span class="title">楼栋图纸配置</span> -->
        </div>
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <!-- <el-scrollbar class=""
                        style="overflow: hidden; margin: 0 10px;"> -->
          <!-- :rules="rules" -->
          <el-form
            :model="buildingForm"
            ref="form"
            label-width="140px"
            style="width: 100%"
          >
            <el-form-item
              :label="buildingForm.type == 2 ? '楼层名称：' : '楼栋名称：'"
              prop="buildingName"
            >
              <!-- <el-input
                v-model="buildingForm.buildingName"
                autocomplete="off"
                :placeholder="'请输入' + buildingLabel"
                :disabled="state == 3"
              ></el-input> -->
              {{ buildingForm.buildingName }}
            </el-form-item>
            <el-form-item
              :label="buildingForm.type == 2 ? '楼层图片：' : '楼栋图纸：'"
              prop="isVisible"
            >
              <!-- <el-upload
                action="common/file/batchFileload.json"
                v-show="state !== 3"
                class="el-upload-single"
                :file-list="fileList"
                ref="addAvatar"
                :multiple="false"
                name="files"
                :show-file-list="true"
                :list-type="'picture-card'"
                accept="image/png, image/jpg, image/jpeg, image/bpm"
                :auto-upload="true"
                :disabled="state == 3"
                :limit="1"
                :before-upload="beforeAvatarUpload"
                :on-success="handleSuccess"
                :on-change="handleChangeFile"
                :on-remove="handleRemove"
                :on-exceed="handleExceed"
              >
                <i class="el-icon-plus"></i>
              </el-upload> -->
              <img
                :src="url"
                class="img-content"
                @click="showViewer(url, $event)"
                onerror="this.src='/images/theme/newDark/default-drawing1.jpg'"
                v-if="state == 3"
              />
            </el-form-item>
            <el-form-item label="配置说明：" prop="name">
              *请选择楼层绑定设备位置
              <!-- {{ buildingForm.desc }} -->
              <!-- <el-input
                v-model="buildingForm.desc"
                autocomplete="off"
                type="textarea"
                :disabled="state == 3"
                placeholder="请输入图纸备注说明"
              ></el-input> -->
            </el-form-item>
            <el-form-item>
              <div style="display: flex; justify-content: center; width: 80%">
                <!-- <el-button type="primary" @click="onSubmit" v-if="state !== 3"
                  >保存信息</el-button
                > -->
                <el-button type="info" @click="retBtn">取消</el-button>

                <el-button
                  v-if="buildingForm.type == 2"
                  type="primary"
                  @click="bindPosition"
                  >绑定设备</el-button
                >
              </div>
            </el-form-item>
          </el-form>
          <!-- </el-scrollbar> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import { Bus } from "$utils";

export default {
  components: {},
  data() {
    return {
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      searchString: "",
      showTree: true,
      treeData: Object.freeze([]),
      // 展开的节点id
      expandedKeys: [],
      lazyLoad: false,
      buildingCode: "", //设备组code
      // 根节点code
      rootCode: "",
      state: 3,
      formShow: false,
      buildingForm: {
        buildingName: "",
        fileCode: "",
        desc: "",
      },
      rules: {
        buildingName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 当前被点击修改新增的设备组的信息
      currentGroupInfo: {},
      imageUrl: "",
      fileList: [{ url: "" }],
      url: "@public/images/theme/newDark/default-drawing1.jpg",
      fileCode: "",
      type: "",
      buildingLabel: "楼栋名称",
      disabled: true,
      iconList: {
        1: "iconfont-lunan icon-lunan-loudongguanli",
        2: "iconfont-lunan icon-lunan-louceng",
      },
      parentCode: "",
      // 返回时带过去路由传递的对象方便查询工作组树
      routerObj: {},
    };
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {
    if (this.$route.query.device) {
      this.routerObj = this.$route.query.device;
    }
    this.queryBuildingTree();
    // this.addUploadBtnDom = this.$refs.addAvatar.$el.childNodes[1];
  },
  destroyed() {},
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    queryBuildingTree() {
      this.$fetch(api.queryBuildingTree).then((res) => {
        const result = this.menusDataPro(res.returnObj);
        this.treeData = Object.freeze(result);
        this.expandedKeys = this.expandedKeys.length
          ? this.expandedKeys
          : [this.treeData[0].id];
        // this.buildingCode = this.treeData[0].id;
        this.nodeClick(this.treeData[0]);
      });
    },
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.buildingCode;
          entity.name = item.buildingName;
          entity.parentCode = item.parentCode;
          entity.type = item.type;
          entity.fileCode = item.fileCode;
          entity.desc = item.desc;
          entity.isLeaf = !item.hasLeaf || !item.subBuildingList;
          if (item.subBuildingList) {
            entity.children = self.menusDataPro(item.subBuildingList);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 单击节点时
    nodeClick(data) {
      // this.addUploadBtnDom.style.display = "inline-block";
      this.buildingCode = data.id;
      this.parentCode = data.parentCode;
      this.buildingLabel = data.type == "2" ? "楼层名称" : "楼栋名称";
      this.type = data.type;
      this.state = 3;
      this.fileList = [];
      this.url = "";
      // if (data.fileCode) {
      this.url = this.getImgPath(data.fileCode);
      this.fileCode = data.fileCode;
      this.fileList.push({ url: this.getImgPath(data.fileCode) });
      // this.addUploadBtnDom.style.display = "none";
      // }
      console.log("fileList", this.fileList);
      this.buildingForm = {
        buildingName: data.name,
        fileCode: data.fileCode,
        desc: data.desc,
        type: data.type,
      };
    },
    addClick(event) {
      event.stopPropagation();
    },
    empty() {
      this.buildingForm = {
        buildingName: "",
        fileCode: "",
        desc: "",
      };
      this.fileList = [];
      // this.addUploadBtnDom.style.display = "inline-block";
    },
    appendArea(data) {
      this.buildingLabel = data.type == "1" ? "楼层名称" : "楼栋名称";
      this.state = 1;
      this.empty();
    },
    removeArea(node, data) {
      this.$confirm("您确定删除该楼栋及下属楼层么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          buildingCode: data.id,
        };
        this.$fetch(api.deleteBuilding, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.expandedKeys = [data.parentCode];
            this.queryBuildingTree();
            this.$message.success("删除成功");
          }
        });
      });
    },
    editArea(node, data) {
      this.state = 2;
    },
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = this.state === 1 ? api.addBuilding : api.updateBuilding;
          let params = {};
          if (this.state === 1) {
            params = {
              buildingName: this.buildingForm.buildingName,
              parentCode: this.buildingCode,
              fileCode: this.buildingForm.fileCode,
              desc: this.buildingForm.desc,
            };
            // if (this.type == 1 && !this.buildingForm.fileCode) {
            //   this.$message.warning('请上传图纸')
            // }
          } else {
            // if (this.type == 2 && !this.buildingForm.fileCode) {
            //   this.$message.warning('请上传图纸')
            // }
            params = {
              buildingCode: this.buildingCode,
              buildingName: this.buildingForm.buildingName,
              fileCode: this.buildingForm.fileCode,
              desc: this.buildingForm.desc,
            };
          }

          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });
              this.expandedKeys = [
                this.state != 1 ? this.buildingCode : params.parentCode,
              ];
              this.queryBuildingTree();
              this.state = 3;
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增修改弹窗 关闭清除数据
    formClose() {
      this.buildingForm = {
        name: "",
        isVisible: "1",
      };
      this.$refs["form"].clearValidate();
    },
    retBtn() {
      // this.$router.go(-1)
      this.$router.push({
        path: "/cameralist/fireDeviceList",
        name: "fireDeviceList",
        query: { device: this.routerObj },
      });
    },
    beforeAvatarUpload(file) {
      const isImg = ["image/png", "image/jpg", "image/jpeg", "image/bpm"].includes(
        file.type
      );
      if (!isImg) this.$message.error("图片类型错误,只能是png/jpg/jpeg/bpm中的一种");
      return isImg;
    },
    handleChangeFile(file, fileList) {
      // this.addUploadBtnDom.style.display = "none";
    },
    handleRemove(file, fileList) {
      this.buildingForm.fileCode = "";
      this.fileList = [];
      // this.addUploadBtnDom.style.display = "inline-block";
    },
    handleExceed(file, fileList) {
      this.$message({
        showClose: false,
        message: this.$t("base.message.fileExceed"),
        type: "error",
        duration: 2000,
      });
    },
    handleSuccess(res, file, fileList) {
      if (res.success) {
        this.buildingForm.fileCode = res.returnObj[0].fileId;
      }
    },
    bindPosition() {
      this.$router.push({
        path: "/cameralist/deviceMap",
        name: "deviceMap",
        query: {
          detail: JSON.stringify({
            buildingCode: this.buildingCode,
            fileCode: this.fileCode,
          }),
        },
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.drawPage {
  width: 100%;
  height: 100%;
  // padding:12px 0px;
  .title {
    margin: 10px 0 10px 10px;
    border-left: 5px solid #407aee;
    padding-left: 10px;
    font-size: 14px;
    // color: #e8eaee;
  }
  .left-tree {
    width: 350px;
    // background-color: rgba(0, 17, 51, 0.4);
    background: #fff;
    height: 100%;
  }
  .right-content {
    background: #fff;
    margin-left: 8px;
    padding: 10px;
  }
  .left-type_area {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .img-content {
    cursor: pointer;
    width: 80%;
    height: 400px;
    object-fit: fill;
  }
  .tree-container {
    flex: 1;
    height: 100%;
    position: relative;
    .area-search {
      display: flex;
      margin: 10px 10px 16px;
      height: 28px;
      .el-input {
        width: 100%;
      }
    }
    .scroll-bar-view {
      height: calc(100% - 55px);
      .el-scrollbar__wrap {
        height: calc(100% - 0px);
        // .el-scrollbar__view {
        //   display: inline-block;
        //   min-width: 100%;
        // }
      }
    }
    .tree-content {
      width: fit-content;
      min-width: 100%;
      .el-tree-node__label {
        display: inline-block;
        max-width: 80%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .el-tree-node__content {
        height: 40px;
        line-height: 40px;
        &:hover {
          background: #fff;
        }
        .custom-tree-node {
          width: 100%;
          height: 40px;
          line-height: 40px;
          display: flex;
          .tree-label {
            max-width: 100%;
          }
          .area-operator {
            display: inline-block;
            margin-left: 10px;
          }
        }
        &:before {
          margin-top: -26px !important;
        }
      }
    }
  }
  .right-top {
    height: 35px;
    align-items: center;
  }

  .el-upload--picture-card,
  .el-upload-single,
  .el-upload-list--picture-card .el-upload-list__item {
    width: 300px;
    height: 300px;
  }
  .el-upload--picture-card i {
    font-size: 50px;
    color: #8c939d;
    line-height: 300px;
  }
}
.el-select {
  width: 100%;
}
</style>
